define("ember-svg-jar/inlined/bttp", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M19.25 4.667l-1.762 4.025-3.558-6.277-3.547 6.452-1.633-4.2s-4.258 7.91-4.258 11.526c0 5.25 4.258 9.509 9.508 9.509 5.25 0 9.508-4.259 9.508-9.509 0-3.78-4.258-11.526-4.258-11.538v.012zM14 22.132c-3.115 0-5.833-2.695-5.833-5.799 0-1.166.536-2.391 1.225-3.5l2.275 3.5L14 10.5l2.333 5.833 2.275-3.5c.677 1.109 1.225 2.334 1.225 3.5 0 3.104-2.718 5.799-5.833 5.799z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});